import { toast } from "sonner";

// Installed apps (home screen) keep old code in memory for days. Check for a new release
// whenever the app comes back to the foreground and reload once if the bundle changed.
const scriptOf = (html) => (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/) || [])[0];
const FLAG = "itz_just_updated";

export function startAutoUpdate() {
  if (localStorage.getItem(FLAG)) {
    localStorage.removeItem(FLAG);
    setTimeout(() => toast.success("Die App wurde aktualisiert ✨", { description: "Du nutzt jetzt die neueste Version.", duration: 4000 }), 1800);
  }
  const current = scriptOf(document.documentElement.innerHTML);
  if (!current) return;
  let last = 0;
  const check = async () => {
    if (document.visibilityState !== "visible" || Date.now() - last < 60000) return;
    last = Date.now();
    try {
      const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
      const next = scriptOf(html);
      if (next && next !== current && !document.activeElement?.matches?.("input, textarea, [contenteditable]")) { localStorage.setItem(FLAG, "1"); window.location.reload(); }
    } catch { /* offline */ }
  };
  document.addEventListener("visibilitychange", check);
  setInterval(check, 5 * 60000);
}
